import React, { useEffect, useRef, useState } from "react";

import { Close } from "@mui/icons-material";

import {
	Avatar,
	Box,
	Button,
	Checkbox,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Drawer,
	IconButton,
	TextField,
	Typography,
} from "@mui/material";
import { debounce } from "lodash";
import { useForm } from "react-hook-form";
import validator from "validator";
import { getProductPreview } from "../../../../apis/Api";
import {
	checkProductExistAPI,
	CreateOscarProduct,
	UpdateOscarProduct,
} from "../../../../apis/Product";
import { FullHeightLoader } from "../../../../components/Loader/FullHeightLoader";
import { showToast } from "../../../../utils/toast";
import { ParsedProductCard } from "./ParsedProductCard";
import FormWrapper from "../../../../components/Form/FormWrapper";

export const ScrapedEditProductDrawer = ({
	setEditOpen,
	editOpen,
	product,
	edit,
	fromGroup,
	setProducts,
}) => {
	const form = useForm();
	const {
		register,
		handleSubmit,
		setValue,
		trigger,
		watch,
		reset,
		formState: { errors },
	} = form;

	const [productPreview, setProductPreview] = useState(null);
	const [productExist, setProductExist] = useState(false);
	const [croppedFile, setCroppedFile] = useState(null);
	const [category, setCategory] = useState(null);
	const [showCategory, setShowCategory] = useState(false);
	const [loading, setLoading] = useState(false);
	const [showColor, setShowColor] = useState(false);
	const handleURLRef = useRef(null);
	useEffect(() => {
		console.log("====================================");
		console.log("product", product);
		console.log("====================================");
		if (product) {
			reset({
				url: product.url ?? "",
				gallery: Array.isArray(product.gallery) ? product.gallery : [],
			});
			setProductPreview(product);
			setCategory(product.product_category);
			setCroppedFile(null);
		} else {
			reset({ url: "" });
			setProductPreview(null);
		}
	}, [product, reset]);
	//   console.log("====================================");
	//   console.log("product", product);
	//   console.log("====================================");
	//   if (product) {
	//     reset({
	//       url: product.url ?? "",
	//     });
	//     setProductPreview(product);
	//     setCategory(product.product_category);
	//   } else {
	//     reset({ url: "" });
	//     setProductPreview(null);
	//   }
	// }, [product]);

	useEffect(() => {
		if (!editOpen) {
			reset({ url: "" });
			setProductPreview(null);
		}
	}, [editOpen, reset]);

	const checkProductExist = async (url) => {
		const result = await checkProductExistAPI(url);
		return !result.product_exist;
	};

	const watchedURL = watch("url");
	const watchedURLRef = useRef(watchedURL);
	watchedURLRef.current = watchedURL;

	const [open, setOpen] = useState(false);
	const [afterSave, setAfterSave] = useState(false);

	const handleClose = () => {
		setOpen(false);
		if (!showColor) {
			setShowColor(true);
		} else {
			setEditOpen(false);
		}
	};

	const [tries, setTries] = useState(0);

	useEffect(() => {
		if (tries === 0) {return;} // Ignore initial render

		if (tries <= 3) {
			console.log("Retry attempt:", tries);
			showToast("Something went wrong, retrying in 5 sec...", "error");
			debounce(async () => {
				await handleURLRef.current(watchedURLRef.current);
			}, 5000)();
		} else {
			// showToast("Unable to parse data, please Try another URL", "error");
		}
	}, [tries]);

	const handleURL = async (product_url) => {
		setLoading(true);
		setProductPreview(null);
		const isValid = await trigger("url");
		if (isValid) {
			const data = await getProductPreview(product_url);

			if (data.success) {
				// added the below code
				if (!data.parser_exist) {
					showToast("Scraper not exist", "error");
					setLoading(false);
					return;
				}
				setShowColor(false);
				setProductPreview(data.data);
				setProductExist(data.product_exist);
			} else {
				if (tries + 1 > 3) {
					showToast(
						data.error ||
						"Unable to parse data, please Try another URL",
						"error"
					);
				}
				setTries((prev) => prev + 1);
			}
		} else {
			console.log(errors);
		}
		setLoading(false);
	};
	handleURLRef.current = handleURL;

	useEffect(() => {
		if (!product && watchedURL) {
			debounce(async () => {
				await handleURLRef.current(watchedURL);
			}, 1000)();
		}
	}, [product, watchedURL]);

	const handleSavanaURL = (url) => {
		if (url.toLowerCase().includes("savana")) {
			const hasQuestionMark = url.includes("?");
			const hasVid = url.includes("vid=");
			const color = productPreview.colors.find(
				({ selected }) => selected
			);
			if (hasQuestionMark) {
				if (!hasVid) {
					if (color) {
						url = `${url}&vid=${color.colorid}`;
					}
				} else {
					if (color) {
						url = url.replace(/(vid=)\d+/, `$1${color.colorid}`);
					}
				}
			} else {
				if (color) {
					url = `${url}?vid=${color.colorid}`;
				}
			}
		}
		return url;
	};

	useEffect(() => {
		if (
			!showColor &&
			productPreview != null &&
			// "colors" in productPreview
			productPreview?.colors?.length > 1
		) {
			setLoading(false);
			setAfterSave(false);
			setOpen(true);
		}
	}, [productPreview, showColor]);

	const onSubmit = async (data) => {
		if (data.out_of_stock) {
			showToast("This Product is Out of stock", "error");
			return;
		}
		setLoading(true);
		const gallery = [...data.gallery];
		console.log(data);
		delete data.gallery;
		delete data.seller;
		delete data.brand;
		delete data.primary_color;
		delete data.secondary_color;
		// delete data.size_details;
		data.size_detail = JSON.parse(data.size_detail);
		console.log(data);
		if (data.product_category_id === "") {
			showToast("category not selected", "error");
			setShowCategory(true);
			setLoading(false);
			return;
		}
		console.log(data);
		if (!edit) {
			data.url = handleSavanaURL(data.url);
		}
		const formData = new FormData();
		if (croppedFile) {formData.append("image", croppedFile);}
		delete data.file;
		Object.entries(data).forEach(([key, value]) => {
			if (typeof value === "object" && value !== null) {
				formData.append(key, JSON.stringify(value));
			} else {
				formData.append(key, value);
			}
		});

		let response;

		if (productExist || edit) {
			response = await UpdateOscarProduct(productPreview.id, formData);
		} else {
			gallery.forEach(({ image }) => {
				formData.append("gallery[]", image);
			});
			// data.gallery = data.gallery.map(({ image }) => image);
			response = await CreateOscarProduct(formData);
		}
		console.log(response);

		if (response.success === true) {
			reset({});
			setProducts((prev) =>
				edit
					? prev.map((p) =>
						p.id === response.products.id
							? response.products
							: p
					)
					: [response.products, ...prev]
			);
			if (productPreview?.colors?.length > 1
				// "colors" in productPreview
			) {
				setLoading(false);
				setAfterSave(true);
				setOpen(true);
			} else {
				setLoading(false);
				setEditOpen(false);
			}
		} else {
			showToast(
				`Failed to ${edit ? "udpate" : "create"}  Product`,
				"error"
			);
			console.error("API call failed", response);
		}
		setLoading(false);
	};

	const handleToggle = (id) => {
		let url = watch("url");

		const hasQuestionMark = url.includes("?");
		const hasVid = url.includes("vid=");
		if (hasQuestionMark) {
			if (hasVid) {
				url = url.replace(/(vid=)\d+/, `$1${id}`);
			} else {
				url = `${url}&vid=${id}`;
			}
		} else {
			url = `${url}?vid=${id}`;
		}
		setValue("url", url);
		setOpen(false);
		setShowColor(true);
		// handleURL(url);
	};

	return (
		<Drawer
			anchor="right"
			open={editOpen}
			onClose={() => setEditOpen(false)}
		>
			<Box
				sx={{
					position: "relative",
					width: 600,
					padding: 1,
					height: "100vh",
					overflowY: "scroll",
					scrollbarWidth: "none", // Firefox
					"&::-webkit-scrollbar": {
						display: "none", // Chrome, Safari, Edge
					},
				}}
			>
				{loading && <FullHeightLoader position={50} />}
				<IconButton
					style={{ position: "fixed" }}
					onClick={() => setEditOpen(false)}
				>
					<Close />
				</IconButton>
				{/* <ToastContainer /> */}

				<FormWrapper onSubmit={handleSubmit(onSubmit)} sx={{ p: 5 }}>
					<Box display="flex" justifyContent="space-between">
						<Typography variant="h6" gutterBottom>{`${edit ? "Edit" : "Add"
							} Product`}</Typography>
						<Button
							disabled={productPreview == null}
							type="submit"
							color="primary"
							variant="contained"
						>
							{edit ? "Update" : "Save"}
						</Button>
					</Box>

					<Box my={3}>
						<TextField
							fullWidth
							label="Paste or enter URL"
							variant="outlined"
							multiline
							minRows={1}
							InputProps={{
								readOnly: product
									? true
									: loading
										? true
										: false,
							}}
							error={Boolean(errors.url)}
							helperText={errors.url?.message}
							{...register("url", {
								required: "Please enter url",
								validate: {
									isURL: (value) =>
										validator.isURL(value) ||
										"Please enter a valid url",
									...(product || fromGroup
										? {} // 👈 skip checkUrl in edit mode
										: {
											checkUrl: async (v) =>
												(await checkProductExist(
													v
												)) ||
												"Product already Exist",
										}),
								},
							})}
						/>
					</Box>

					{productPreview && (
						<Box my={3}>
							<ParsedProductCard
								croppedFile={croppedFile}
								setCroppedFile={setCroppedFile}
								product={productPreview}
								category={category}
								setCategory={setCategory}
								showCategory={showCategory}
								setShowCategory={setShowCategory}
								form={form}
							/>
						</Box>
					)}
				</FormWrapper>
				{productPreview && "colors" in productPreview && (
					<Dialog
						open={open}
						keepMounted
						onClose={() => { }}
						aria-describedby="alert-dialog-slide-description"
					>
						<DialogTitle>{"Confirmation"}</DialogTitle>
						<DialogContent>
							<DialogContentText id="alert-dialog-slide-description">
								<b>{productPreview?.name}</b> product have
								different color varients
								<br />
							</DialogContentText>

							<Box
								sx={{
									display: "flex",
									flexWrap: "wrap",
									gap: 1,
									my: 1,
								}}
							>
								{productPreview?.colors.map((item, index) => (
									<Checkbox
										key={`color-${index}`}
										value={item.colorid}
										onChange={(_, id) => {
											setLoading(false);
											handleToggle(item.colorid);
										}}
										checked={item.selected}
										disabled={!item.available}
										icon={
											<Avatar
												src={item.image}
												variant="rounded"
												sx={{
													opacity: item.available
														? 1
														: 0.4, // visually dim if disabled
													filter: item.available
														? "none"
														: "grayscale(100%)", // grayscale if disabled
												}}
											/>
										}
										checkedIcon={
											<Avatar
												src={item.image}
												variant="rounded"
												sx={{
													p: 1,
													width: 40,
													height: 40,
													border: "2px solid black",
													opacity: item.available
														? 1
														: 0.4,
													filter: item.available
														? "none"
														: "grayscale(100%)",
												}}
											/>
										}
										sx={{ p: 1 }}
									/>
								))}
							</Box>
						</DialogContent>
						{/* <DialogActions>
							<Button onClick={handleClose}>No</Button>
						</DialogActions> */}
						{afterSave && (
							<DialogActions>
								<Button onClick={handleClose}>No</Button>
							</DialogActions>
						)}
					</Dialog>
				)}
			</Box>
		</Drawer>
	);
};
